// extracted by mini-css-extract-plugin
module.exports = {"editorContainer":"textEditor_editorContainer__2po8h"};